import { render, staticRenderFns } from "./adverseDetail.vue?vue&type=template&id=1aea566e&scoped=true"
import script from "./adverseDetail.vue?vue&type=script&lang=js"
export * from "./adverseDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aea566e",
  null
  
)

export default component.exports